// extracted by mini-css-extract-plugin
export default {"paymentMethods":"AJD1EU1IMqdR2tpqPE0X","historyTable":"S7jK3UmUlvFgww9GO6cc"};